// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/ToggleLocationConnection/SetupAutomations/Content/Content/Content/Steps/Content/ActiveStep/Automation/Event/DocumentSigned/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_ConnectApps_App_Content_Connections_Content_ActionsColumn_ToggleLocationConnection_SetupAutomations_Content_Content_Content_Steps_Content_ActiveStep_Automation_Event_DocumentSigned($location_id: uuid!) {
  vaxiom_document_templates(
    where: {
      _or: [
        { organization: { level: { _neq: "location" } } }
        {
          organization: {
            _id: { _eq: $location_id }
            level: { _eq: "location" }
          }
        }
      ]
    }
    order_by: { name: asc }
  ) {
    id
    _id
    name
  }
}

`